import { render, staticRenderFns } from "./LessLessonsThanPeriodicity.vue?vue&type=template&id=473152d3&"
import script from "./LessLessonsThanPeriodicity.vue?vue&type=script&lang=js&"
export * from "./LessLessonsThanPeriodicity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports